import axios from "axios";
import Vue from "vue";
import { getDeviceNo } from "@/util/device";
import { getChannel } from "@/util/channel";
import { store } from "@/store/index.js";
import { db } from "@/mixins/playSvgamixin";
import { aesDecode } from "@/util/aes";

Vue.prototype.$axios = axios;

let device_no = "";

db.find("device").then((d) => {
  if (d) {
    device_no = d;
    localStorage.setItem("device_no", device_no);
  } else {
    getDeviceNo().then((device) => {
      // 2d4641b6642e61ce34be436a02937e42
      device_no = device ?? (Date.now() + Math.random() * 1000000).toString();
      db.insert("device", device_no).then();
      localStorage.setItem("device_no", device_no);
    });
  }
});

const instance = axios.create({
  baseURL: ENV === "dev" ? "/proxy" : API_URL,
  // baseURL: ENV === "dev" ? "https://test_api.mliveplus.com" : API_URL,
  timeout: 20000,
  // withCredentials: true, //跨域影响，是否带cookie
});
instance.interceptors.request.use(
  async (config) => {
    // if (md5Apis[config.url]) {
    //   config = md5RequestParams(config)
    // }

    // encrypt_on 为1返回加密密文
    // config.data.encrypt_on = 1;

    let token = localStorage.getItem("token");
    let id = localStorage.getItem("id");
    if (!device_no) {
      const cached = localStorage.getItem("device_no");
      if (cached) {
        device_no = cached;
      } else {
        const generated = await getDeviceNo();
        device_no = generated ?? (Date.now() + Math.random() * 1000000).toString();
        localStorage.setItem("device_no", device_no);
        db.insert("device", device_no).then();
      }
    }
    console.error(getChannel());
    config.headers["Authorization"] = `token=${token}; uid=${id}`;
    config.headers["platform"] = "0";
    config.headers["device-info"] = device_no;
    config.headers["reg-source"] = IS_njbnrkeji ? "UD70IUQQ" : getChannel();
    config.headers["lang"] = LOCALE == "zh-CN" ? "zh_cn" : "en";

    return config;
  },
  (err) => {
    return Promise.reject(err);
  }
);
instance.interceptors.response.use(
  async (res) => {
    if (res.data.status === 2) {
      store.commit("changeUserInfo", {
        id: "",
        diamond: 0,
        gold: 0,
      });
      localStorage.removeItem("userInfo");
      localStorage.removeItem("token");
      localStorage.removeItem("id");
      // 登录超时清掉 TIM sig 缓存（避免与 tim.js 循环依赖，直接清 key）
      try {
        sessionStorage.removeItem("tim_user_sig_cache");
      } catch (e) {
        /* ignore */
      }
      if (!store.state.showLogin) {
        store.commit("toggleLogin");
      }

      return Promise.reject(new Error("登录超时"));
    }

    if (res.data.status === 1) {
      // Vue.prototype.$message.error(res.data.msg);
      return Promise.reject(new Error(res.data.msg));
    }

    // if (res.config.url.indexOf("/api/home/getLongMenBg") === -1) {
    //   res.data.data = await decodeResponseData(res.data.data); //接口解密
    // }
    if (IS_ENCRYPT === 1) {
      res.data.data = await aesDecode(res.data.data); //接口解密
    }
    if (res.config.url !== "/api/maintain") {
      console.log("\n======API result start=====");
      console.log("接口:", res.config.url);
      console.log("入参:", res.config.data);
      console.log("返回:", JSON.parse(JSON.stringify(res.data.data)));
      console.log("======API result end=========\n");
    }

    return res;
  },
  (err) => {
    // Vue.prototype.$message.warning("请求超时，请稍后再试");
    return Promise.reject(err);
  }
);

export const post = ({ req, data, url, header }) => {
  if (!data) {
    data = {};
  }

  return instance.post(url, data, { headers: header });
};

export const get = ({ req, data, url }) => {
  if (!data) {
    data = {};
  }

  return instance.get(url, {
    params: data,
    data,
  });
};
